import { useIsFetching } from '@tanstack/react-query';
import { Loader2 } from 'lucide-react';

import { Stack } from '@/lib/shadcn/components/ui/stack/stack';

export const Loader = () => {
  const isFetching = useIsFetching({
    predicate: (query) => {
      return !query.queryKey.includes('ignoreLoading');
    },
  });

  if (!isFetching) return null;

  return (
    <Stack
      align="center"
      justify="center"
      className="fixed inset-0 z-[1002] size-full bg-white"
    >
      <Loader2 className="size-14 animate-spin text-teal-400" />
    </Stack>
  );
};
